<template>
  <div>
    <div class="tw-my-4">
      <back-nav :to="backNavTo" />
    </div>
    <v-card v-if="!pageLoading" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-5 md:tw-mt-10 tw-pb-5">
      <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
        Instalment Payment
        <hr class="tw-mt-4">
      </h3>
      <div class="tw-w-full tw-flex tw-flex-col">
        <div v-if="policy.productCode === 702 " class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
          <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
            <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
              <p class="c-gray-text">Instalment</p>
              <h1 class="tw-w-full c-gray-text tw-font-bold tw-text-6xl">
                {{ formatDateToMonth(scanObject(policy, 'paymentSchedule.0.dueDate'))  }}
              </h1>
            </div>
            <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ paymentSchedule[0].amount  | formatNum }}</h3>
              <v-btn color="secondary" class="tw-mt-2" large block :loading="loading" @click="proceed(paymentSchedule[0].amount)">Confirm and Pay</v-btn>
            </div>
          </v-card>
        </div>
        <template v-else>
          <div v-if="unpaidSchedule.length === 2 && $route.query.full" class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
            <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
                <p class="c-gray-text">All Remaining Installments</p>
                <h1 class="tw-w-full c-gray-text tw-font-bold tw-text-6xl">60%</h1>
                <p class="tw-w-full c-gray-text tw-text-base">of total premium</p>
              </div>
              <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ (paymentSchedule[0].amount + paymentSchedule[1].amount)  | formatNum }}</h3>
                <v-btn color="secondary" class="tw-mt-2" large block :loading="loading" @click="proceed(paymentSchedule[0].amount + paymentSchedule[1].amount, 60)">Confirm and Pay</v-btn>
              </div>
            </v-card>
          </div>

          <div class="tw-w-full tw-flex tw-flex-col">
            <div v-for="(p, $index) in unpaidSchedule" :key="$index" class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
              <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
                <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
                  <p class="c-gray-text">{{$index === 0 ? 'Second' : 'Third' }}  Instalment</p>
                  <h1 class="tw-w-full c-gray-text tw-font-bold tw-text-6xl">{{ p.distribution }}%</h1>
                  <p class="tw-w-full c-gray-text tw-text-base">of total premium</p>
                </div>
                <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                  <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                  <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ p.amount | formatNum }}</h3>
                  <h4 class="c-blue-text tw-font-bold tw-text-base tw-mt-2">Due {{ p.dueDate }} </h4>
                  <v-btn v-if="$index === 0" color="secondary" class="tw-mt-2" large block :loading="loading" @click="proceed(p.amount, p.distribution)">Confirm and Pay</v-btn>
                </div>
              </v-card>
            </div>
          </div>
        </template>
      </div>
    </v-card>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="40"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import helpers from '@/utils/helpers';
import { mapState } from 'vuex';
import BackNav from '@/components/buy/BackNav';
import { FB_RENEW_INSTALMENTS } from '@/utils/const';
import axios from 'axios';
import { formatDateToMonth } from '@/utils/time';

export default {
  name: 'Instalments',
  components: { BackNav },
  props: ['renewal'],
  data() {
    return {
      loading: false,
      pageLoading: true,
    };
  },
  computed: {
    policy() {
      return this.$store.state.policy;
    },
    paymentSchedule() {
      return this.policy.paymentSchedule;
    },
    unpaidSchedule() {
      return this.paymentSchedule !== null ? this.paymentSchedule.filter((p) => p.paymentStatus === 'PENDING') : [];
    },
    ...mapState({
      user: (state) => state.auth.user,
    }),
    quote() {
      return this.$store.getters['renewal/fetchQoute'];
    },
    backNavTo() {
      return this.scanObject(this.$route, 'query.type', '') === 'instalment' ? null : 'BranchSelectionReview';
    },
  },
  metaInfo: {
    title: 'Renew - Payment Installments',
  },
  mounted() {
    this.$store.dispatch('getPolicy', this.$route.params.policyNo).then(() => {
      this.pageLoading = false;
      if (this.policy.paymentSchedule === null) {
        this.$toast.warning('No Pending Instalments', 'Policy Payment');
        this.$router.push({ name: 'SinglePolicy', params: { policyNo: this.policy.policyNo } });
      }
    });
  },
  methods: {
    formatDateToMonth,
    proceed(amount, percentage) {
      const payment = {
        payableAmount: amount,
        kraPin: this.user['custom:kra-pin'],
        accountReference: this.policy.risks[0].regno,
        description: `ext-${this.renewal.batchId}`,
        customerPhoneNumber: this.user.phone_number,
      };
      // eslint-disable-next-line no-unused-vars
      let coverTypeName = null;

      if (this.policy.coverCode === 120) {
        coverTypeName = `${this.policy.productCode === 702 ? 'Bima Bamba' : 'Comprehensive'}<br> Insurance Cover`;
      } else {
        coverTypeName = 'Third Party <br> Only';
      }

      const quoteInfo = {
        // eslint-disable-next-line no-nested-ternary
        coverType: coverTypeName,
        payPercentage: percentage,
        client: this.quote.client,
        paymentSchedule: this.policy.paymentSchedule,
      };
      const data = {
        quoteId: this.quote.quoteId,
        premium: amount,
        paymentType: percentage === 100 ? 'YEARLY' : 'MONTHLY',
      };
      axios.post('/customer/quotation/policy/update/policy-premium', data).then(() => {
        this.$analytics.logEvent(FB_RENEW_INSTALMENTS, { product: 'Renewal Journey select instalments' });
        this.$emit('to-make-payment', { data: { payment, quoteInfo } });
      });
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
